import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css";
// import Sidebar from "../../img/sidebar.png";
import Ecom from "../../img 2/Ecom.jpg";
import Java from "../../img2/java.png";
import Mern2 from "../../img2/Mern2.png";
import { themeContext } from "../../Context";
const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span style={{color: darkMode?'white': ''}}>Major Projects</span>
      <span>Portfolio</span>

      {/* slider */}
      <Swiper
        spaceBetween={30}
        slidesPerView={3}
        grabCursor={true}
        className="portfolio-slider"
      >
        <SwiperSlide>
          {/* <a href="https://github.com/Mayankmishra110/Social-Media">
          <img src={Mern2} alt="" />
          </a> */}
        </SwiperSlide>
        <SwiperSlide>
          <a href="https://github.com/Mayankmishra110/E-Commerce-React">
          <img src={Ecom} alt="" />
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="https://github.com/Mayankmishra110/Student-Library-Management-System">
          <img src={Java} alt="" />
          </a>
        </SwiperSlide>
        <SwiperSlide>
          <a href="https://github.com/Mayankmishra110/My-React-Portfolio">
          <img src={Mern2} alt="" />
          </a>
          </SwiperSlide>
          <SwiperSlide>
          <a href="https://github.com/Mayankmishra110/Book-My-Show">
          <img src={Java} alt="" />
          </a>
          </SwiperSlide>
        
      </Swiper>
    </div>
  );
};

export default Portfolio;
